module.exports = __webpack_public_path__ + "media/images/symbols/favicon-68792cc7d2a3848037c6a859393a5a06.svg";